/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { CustomFilterV2, TableV2, DialogDefaultV2 } from '../../../components/v2';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as actionsInspecaoVeicular from '../../../store/inspecaoVeicular/actions';
import Formulario from './Formulario';
import * as Roles from '../../../constants/role';
import moment from 'moment';
import {
  Box,
  Typography,
  Stack,
  Button,
  DialogContentText,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';

const InspecaoVeicularV2 = ({ inspecaoVeicularReport, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().endOf('month').valueOf(),
  });
  const [reload, setReload] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
  };

  const onClose = (save) => {
    setOpen(false);
    setId(null);
    if (save) {
      setReload(!reload);
    }
  };

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const headerActions = [
    {
      label: 'Novo',
      onClick: onAdd,
      startIcon: <AddIcon />,
      variant: 'contained',
    },
  ];

  if (isAdmin()) {
    headerActions.push({
      label: 'Relatório',
      onClick: () => setOpenExport(true),
      startIcon: <DescriptionOutlinedIcon />,
      variant: 'outlined',
    });
  }

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">
            Inspeções Veiculares
          </Typography>

          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          useApi
          fetchUrl="inspecao-veicular/filter"
          rowHeight={70}
          headerActions={headerActions}
          columns={[
            { field: 'dataInspecaoValue', headerName: 'Data da Inspeção', width: 150 },
            { field: 'inspetorNome', headerName: 'Inspetor', flex: 0.5 },
            { field: 'inspetorAuxiliarNome', headerName: 'Inspetor Auxiliar', flex: 0.5 },
            { field: 'veiculoPlaca', headerName: 'Veículo', width: 130 },
            { field: 'observacao', headerName: 'Observação', flex: 0.7 },
          ]}
          onEdit={onEdit}
          showDelete={false}
          filterData={localFilter}
          refreshKey={reload}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useDates' },
            { field: 'useInspetor', multiSelect: true, md: 12 },
            { field: 'useInspetor', multiSelect: true, md: 12, label: 'Inspetor Auxiliar', key: 'inspetorAuxiliarId' },
            { field: 'useVeiculo', md: 12 },
          ]}
          defaultFilter={{
            inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
            fim: moment().endOf('month').valueOf(),
          }}
          onFilter={filterData => {
            setLocalFilter(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          onReload={() => setReload(!reload)}
        />

        <DialogDefaultV2
          open={openExport}
          useFullScreen={false}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            inspecaoVeicularReport(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
        </DialogDefaultV2>
      </Stack>
    </Box>
  );
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsInspecaoVeicular
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InspecaoVeicularV2));
